module.exports = __webpack_public_path__ + "static/media/organization-groups.4b17ef26.png";